export default "__VITE_ASSET__Ogcf6W2y__"